{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowNwIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowNwIcon = React.forwardRef<SVGSVGElement, ArrowNwIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 108 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M61.9579 58.1272C74.5806 70.9551 87.1968 83.7895 99.8063 96.63C102.315 99.1944 104.656 101.933 106.934 104.708C107.306 105.17 107.531 105.735 107.578 106.327C107.624 106.92 107.491 107.512 107.196 108.028C106.754 108.885 105.11 109.086 104.111 108.36C103.145 107.656 102.11 107.028 101.219 106.239C95.533 101.201 89.7113 96.3005 84.2479 91.0295C73.0246 80.1999 61.9442 69.222 50.9059 58.2067C40.4308 47.7552 30.0999 37.1612 19.6589 26.6736C17.9833 24.9894 16.0904 23.5199 14.2632 21.9926C14.1245 21.9087 13.967 21.861 13.8051 21.8539C13.6431 21.8468 13.482 21.8805 13.3365 21.9519C13.0471 22.181 12.686 22.6909 12.7654 22.96C14.233 27.9239 15.57 32.9363 17.3165 37.8044C21.3799 49.1243 24.1424 60.7893 26.8911 72.4643C27.342 74.3828 27.8383 76.3702 26.8604 78.3057C26.6825 78.6582 26.3641 79.2469 26.1646 79.2246C25.4004 79.1981 24.6548 78.9827 23.9942 78.5978C23.3714 78.1064 22.8971 77.4517 22.6243 76.7068C21.6398 74.0894 20.7019 71.449 19.8677 68.781C13.8806 49.7117 7.95259 30.6241 1.93923 11.5627C-0.329078 4.37322 -0.191973 -0.257966 10.8916 0.0111321C14.086 0.0879236 17.2975 0.185773 20.463 0.576294C35.1466 2.38954 49.8212 4.27102 64.4868 6.22078C66.4483 6.54417 68.3816 7.01991 70.2692 7.6437C71.5333 8.01847 72.0893 9.10213 72.2632 10.3426C72.4548 11.7084 71.2314 13.898 70.2121 14.3797C67.9497 15.4496 65.5397 15.4844 63.1565 15.3157C53.9835 14.6646 44.8157 13.9301 35.6487 13.1911C29.676 12.7093 23.7125 12.1534 17.7412 11.6815C17.4458 11.6585 17.0158 12.0753 16.8281 12.3897C16.7612 12.5418 16.7323 12.7079 16.7437 12.8737C16.7551 13.0394 16.8067 13.1999 16.8938 13.3414C18.469 15.1358 20.0134 16.9631 21.7074 18.6394C35.0682 31.8606 48.4469 45.0642 61.8432 58.25L61.9579 58.1272Z" fill={color}/>

      </svg>
    )
  }
)

ArrowNwIcon.displayName = 'ArrowNwIcon'
